/**
 * @desc: - 弹出框 (普通弹出框)
 * @param  {[STRING]} className： [顶层class]
 * @param  {[STRING]} title：     [顶部文字]
 * @param  {[STRING]} text：      [显示内容]
 * @param  {[FUNCTION]} confirm: [点击confirm之后的回调函数]
 * @param  {[FUNCTION]} cancel: [点击cancel之后的回调函数]
 * @param  {[bool]} display: [是否显示弹出框]
 * @author: circle
 * @example:<Confirm cancel = {this.props.bind(this)} text="内容<br/>打就打上了多久" confirm = {this.confirm.bind(this)}  display = {this.state.display}/>
 */
import React from 'react';
import ReactDOM from 'react-dom'

export default class Confirm extends React.Component {
  constructor(props) {
    super(props);
    this.modalPosition = this.modalPosition.bind(this);
    window.onresize = ()=>{
      this.modalPosition()
    }
  }

  componentDidUpdate(){
    this.modalPosition(true)
  }
  
  modalPosition(props = null){
    if (!this.props.display || !props) {return;}
    let modalTop = (document.documentElement.clientHeight/2 - this.refs.alertModal.offsetHeight/2) + 'px';
    this.refs.alertModal.style.top = modalTop;
  }

  render() {
    let { className, title, text, display, close, confirm, extendButtons, confirmBtnText} = this.props;
    title = title || "prompt";
    className = className || 'modal-original';
    const style = { 
      display: display ? 'block' : 'none'
    } 

    return (
      <div>
        <div className={className} style={style} ref="alertModal">
          <h3 className="title">{'prompt'}</h3>
          <div id="block_content" className="content">
            <div className="detail" dangerouslySetInnerHTML = {{__html:text}}></div>
          </div>
          <div id="block_bottom" className="bottom">
              <input type="button" value={confirmBtnText?confirmBtnText:'confirm'} ref="closeBtn" width="50%" height="43" className="submit" onClick={confirm}/>
              <input type="button" value="cancel" className="cancel"  onClick={close}/>&nbsp;&nbsp;
              {
                  extendButtons && extendButtons.length > 0 ?
                      extendButtons.map((item, index) => <input key={index} type='button' className="extend" value={item.text} onClick={item.action}/>) : null
              }
          </div>
        </div>
      </div>
    );
  }
}
